import { useMemo } from 'react';
import { Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { GenerationToolIcon } from 'src/components/GenerationToolIcon';
import { ASSET_TYPE, getAssetChannelLabel, getAssetLabel } from 'src/data/asset';
import {
  GENERATION_TOOL,
  getToolClassifiedMixtureSubGenerationTools,
  getToolDefaultAssetType,
  getToolDescription,
  getToolMixtureSubGenerationTools,
  getToolTitle,
  isMixtureTool,
  isToolVariationLabelWithoutDescription,
  mapGenerationTool,
} from 'src/data/generationTool';

import { useStyles } from './useStyles';

export const VariationFormat = ({
  className,
  classes,
  assetType,
  generationTool,
  mixtureSubAssetType,
  showInsightsLabel,
}) => {
  const styles = useStyles({ classes });

  const mixtureTool = () => {
    const mixtureTools = [
      ...getToolMixtureSubGenerationTools(generationTool),
      ...getToolClassifiedMixtureSubGenerationTools(generationTool),
    ];
    return mixtureTools.filter((tool) => getToolDefaultAssetType(tool) === mixtureSubAssetType)[0];
  };

  const resolvedTool =
    isMixtureTool(generationTool) && !getToolTitle(generationTool) ? mixtureTool() : generationTool;

  const toolIcon = resolvedTool;
  const toolTitle = getToolTitle(resolvedTool);
  const mappedTool = mapGenerationTool(resolvedTool);
  const toolDescription = getToolDescription(mappedTool);

  const inputDescription = useMemo(() => {
    if (isToolVariationLabelWithoutDescription(mappedTool)) {
      return '';
    }
    return mixtureSubAssetType
      ? ` - ${getAssetLabel(mixtureSubAssetType)}`
      : toolDescription &&
        mappedTool !== GENERATION_TOOL.emailPromotionalBody &&
        mappedTool !== GENERATION_TOOL.emailColdOutreachBody &&
        mappedTool !== GENERATION_TOOL.emailBody &&
        mappedTool !== GENERATION_TOOL.emailSubject
      ? ` - ${toolDescription}`
      : '';
  }, [mixtureSubAssetType, toolDescription, mappedTool]);

  return (
    <div className={cx(styles.root, className)}>
      <GenerationToolIcon
        className={styles.icon}
        tool={toolIcon}
      />
      <Typography className={styles.title}>
        {toolTitle || getAssetChannelLabel(assetType)}
        {inputDescription}{' '}
        {showInsightsLabel && (
          <>
            <span>•</span> Insights
          </>
        )}
      </Typography>
    </div>
  );
};

VariationFormat.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  assetType: PropTypes.oneOf(Object.values(ASSET_TYPE)),
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)),
  mixtureSubAssetType: PropTypes.string,
  showInsightsLabel: PropTypes.bool,
};

VariationFormat.defaultProps = {
  className: null,
  assetType: null,
  generationTool: null,
  classes: null,
  mixtureSubAssetType: null,
  showInsightsLabel: null,
};
